import * as React from "react";
const SvgIcChevronRight = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="m6.91 14.067 3.824-3.825L6.91 6.417l1.184-1.175 5 5-5 5-1.184-1.175Z" /></svg>;
export default SvgIcChevronRight;